import React from "react";
import "./PictureInitials.scss";

const generateColor = (firstName, lastName) => {
  const stringToHash = `${firstName}${lastName}`;
  let hash = 0;

  for (let i = 0; i < stringToHash.length; i++) {
    hash = stringToHash.charCodeAt(i) + ((hash << 5) - hash);
  }

  const color = `hsl(${hash % 360}, 70%, 50%)`; // Generate an HSL color
  return color;
};

const PictureInitials = ({ first_name = "", last_name = "" }) => {
  const initials =
    (first_name[0] ? first_name[0].toUpperCase() : "") +
    (last_name[0] ? last_name[0].toUpperCase() : "");
  const backgroundColor = generateColor(first_name, last_name);

  return (
    <div className="profileCircle" style={{ backgroundColor }}>
      <p className="profileInitials">{initials || "AZ"}</p>
    </div>
  );
};

export default PictureInitials;
